import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import List from '@material-ui/core/List'
import DragHandle from '@material-ui/icons/DragHandle'
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from 'react-sortable-hoc'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({
  avatar: {
    background: 'none',
    color: theme.palette.primary[500]
  },
  listItem: {
    cursor: 'ns-resize',
    zIndex: 1501,
    color: theme.palette.primary[500]
  },
  listRoot: {
    paddingTop: 0,
    paddingBottom: 0
  }
})

const SortableItem = SortableElement(({ item, theme, classes }) => (
  <ListItem key={item.key} className={classes.listItem} divider>
    <ListItemIcon>
      <DragHandle
        style={{ color: theme.palette.primary.main }}
        color="inherit"
      />
    </ListItemIcon>
    <ListItemText primary={item.name} />
  </ListItem>
))
const SortableList = SortableContainer(({ items, theme, classes }) => (
  <List classes={{ root: classes.listRoot }}>
    {items.map((item, index) => (
      <SortableItem
        key={item.key}
        index={index}
        item={item}
        classes={classes}
        theme={theme}
      />
    ))}
  </List>
))
class ReorderModal extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired,
    onChangeOrder: PropTypes.func.isRequired
  }
  state = {
    items: [],
    changed: false
  }
  componentDidMount() {
    this.setState({
      items: [...this.props.items.sort((a, b) => a.order > b.order)]
    })
  }

  handleOk = e => {
    this.props.onChangeOrder(this.state.items)
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState({
      changed: true,
      items: arrayMove(this.state.items, oldIndex, newIndex)
    })
  }
  render() {
    const { classes, theme } = this.props
    const { items } = this.state
    return (
      <ModalWrapper
        open
        onOk={this.handleOk}
        title="Ordre d'affichage"
        cancelText="Fermer"
        okText="Mettre à jour"
        showOk
        okDisabled={!this.state.changed}>
        <Grid container direction="row" alignItems="center" justify="center">
          <Grid item>
            <Paper>
              <SortableList
                lockToContainerEdges
                items={items}
                classes={classes}
                theme={theme}
                onSortEnd={this.onSortEnd}
              />
            </Paper>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles, { withTheme: true })(ReorderModal)



// WEBPACK FOOTER //
// ./src/components/modals/admin/ReorderModal.js